import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564a1f0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue-tl-plan-purchase-component" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = {
  key: 0,
  class: "plans"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_6 = {
  key: 1,
  class: "gst-info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "*AUD +GST where applicable.", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "current-card"
}
const _hoisted_10 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PriceComponent = _resolveComponent("PriceComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_CardChooserComponent = _resolveComponent("CardChooserComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedPlan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_PriceComponent, {
            cents: _ctx.selectedPlan.Price,
            "is-taxable": _ctx.selectedPlan.Taxable
          }, null, 8 /* PROPS */, ["cents", "is-taxable"]),
          (_ctx.plans.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: plan.PlanId,
                      class: _normalizeClass({ 'plan-selected': plan.PlanId === _ctx.selectedPlan.PlanId }),
                      onClick: ($event: any) => (_ctx.selectPlan(plan))
                    }, [
                      _hoisted_5,
                      _createElementVNode("span", null, _toDisplayString(plan.ButtonCopy), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_4))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_ButtonComponent, {
            disabled: _ctx.disabled,
            onClick: _withModifiers(_ctx.handlePurchasePlan, ["prevent"])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "button-text-slot", {}, () => [
                _createTextVNode(" Purchase ")
              ], true)
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["disabled", "onClick"]),
          (_ctx.selectedPlan.Taxable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("v-if", true),
          (_ctx.hasValidCard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(" With card ending in: "),
                _createElementVNode("span", {
                  title: `expiry: ${_ctx.selectedCard?.Expiry}`
                }, _toDisplayString(_ctx.selectedCard?.Last4), 9 /* TEXT, PROPS */, _hoisted_10),
                _createTextVNode(", or "),
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleChoosingDifferentCard && _ctx.toggleChoosingDifferentCard(...args)), ["prevent"]))
                }, "use a different card"),
                _createTextVNode(". ")
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_CardChooserComponent, { onSelectedCardChanged: _ctx.cardChanged }, null, 8 /* PROPS */, ["onSelectedCardChanged"])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_LoadingComponent, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"])
  ]))
}